import React from 'react';
import { Card, Col, Row } from 'react-bootstrap-5';

import OffMarketPropertyImage from './results/off_market_property_image';
import OffMarketCompSummary from './results/off_market_comp_summary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { connect } from 'react-redux';
import { setOffMarketPropertyId } from 'bundles/connect/components/store/actions/off_market_property';
import { setOffMarketPropertyId as setOffMarketPropertyIdTurbo } from '../helpers/navigation_helper';
import type { InsightsProperty } from 'bundles/connect/types';

type OffMarketCompDetailsCardProps = {
  fromTurbo?: boolean;
  property: InsightsProperty;
  setOffMarketPropertyId: (id: string) => void;
  onRemoval: (id: string) => void;
}

function OffMarketCompDetailsCard(
  { fromTurbo = false, property, setOffMarketPropertyId, onRemoval }: OffMarketCompDetailsCardProps
) {
  const handlePropertyClick = (id) => {
    setOffMarketPropertyId(id);
    if (fromTurbo) {
      setOffMarketPropertyIdTurbo(id);
    }
  };

  const handleRemoval = (e) => {
    e.stopPropagation();
    onRemoval(property.propertyId);
  };

  return (
    <Card className="h-100 clickable" onClick={() => handlePropertyClick(property.propertyId)}>
      <Row className="g-0 align-items-stretch h-100">
        <Col className="d-flex flex-column">
          <Card.Body className="p-2">
            <div
              className={
                `d-flex
                bg-light
                rounded-circle
                clickable
                position-absolute
                justify-content-center
                align-items-center
                z-3`
              }
              style={{ width: 24, height: 24, top: 5, right: 5 }}
              onClick={handleRemoval}
            >
              <FontAwesomeIcon icon={faTimes} />
            </div>
            <OffMarketCompSummary property={property} />
          </Card.Body>
        </Col>
        <Col className="map-result-thumb off-market-result-thumb d-none d-md-block" md="auto">
          <OffMarketPropertyImage result={property} />
        </Col>
      </Row>
    </Card>
  );
}

export default connect(undefined, { setOffMarketPropertyId })(OffMarketCompDetailsCard);
